/**
 * ローカルストレージキー
 */
export const FIRST_ACCESSED = 'first_accessed'
export const BRIDAL_ITEM_IRREGULAR = 'bridal_item_irregular'

/**
 * ローカルストレージから値を取得する
 * @param {string} key キー
 * @param {*} defaultVal キーが見つからなかったときの返却値
 * @returns {*} 取得結果
 */
export function getLocalStorage(key, defaultVal) {
  let result = defaultVal
  try {
    const json = localStorage.getItem(key)
    if (json !== null) {
      // JSONパースして取得
      result = JSON.parse(json)
    }
  } catch(e) {
    localStorage.removeItem(key)
  }
  return result
}

/**
 * ローカルストレージに値を保存する
 * @param {string} key キー
 * @param {*} val 値
 */
export function saveLocalStorage(key, val) {
  // JSONにして保存
  localStorage.setItem(key, JSON.stringify(val))
}

/**
 * ログアウト時のクリア処理
 */
export function clearLocalStorageOnLogout() {
  localStorage.removeItem(BRIDAL_ITEM_IRREGULAR)
}